export default [
    {
        id: 'jackson',
        name: "Jackson",
        display: false
    },
    {
        id: 'wedding',
        name: "Wedding",
        display: false
    },
    {
        id: 'birth',
        name: 'Birth',
        display: true,
    },
    {
        id: 'first-month',
        name: 'First Month',
        display: true,
    },
    {
        id: 'second-month',
        name: 'Second Month',
        display: true,
    },
    {
        id: 'wedding-photos',
        name: 'Wedding-Photos',
        display: true,
    },
    {
        id: 'wedding-ceremony-photos',
        name: 'Wedding Ceremony Photos',
        display: true,
    }
]